module.exports = __webpack_public_path__ + "images/category_lp/retro_game/assessment_achievements/6_4ef216eb48d2923a22e95eb5c9df3b3d.png";